import styled from 'styled-components';
export const Container = styled.div`
 padding : 20px 1px 0 1px;
 border-bottom : 1px solid #d2d2d2;
 box-sizing : border-box;
 width : calc(100% - 2px);
`;

export const NickName = styled.div`
  text-align: left;
  font-size :14px;
  font-weight: bold;
  cursor: pointer;
`;

export const Profile = styled.img`
  width: 18px;
  height: 18px;
  border: 0.5px solid  #eeeeee;
  border-radius: 10px;
  margin-right: 5px;
  cursor: pointer;
  src: ${props => props.src}
  alt: ${props => props.alt}
`

export const Text = styled.div`
  font-size : 12px;
  font-weight : 300;
  text-align : left;
  word-break : break-all;
  max-width : 274px;
`;
export const Div = styled.div`
  display : flex;
  flex-direction : ${props => props.column ? "column" : "row"};
  margin : ${props => props.margin ? props.margin : "0px"};
  justify-content : ${props => props.justifyContent ? props.justifyContent : "space-between"};
  align-items : center;
  width: ${props => props.width ? props.width : "auto"}
`;

export const Button = styled.div`
    background : none;
    border : 0;
    color : black;
    font-size : 12px;
    margin : ${props=> props.margin ? props.margin : "0"};
    width : 18px;
    cursor: pointer;
    img{
      width : ${props => props.width ? props.width : "100%"};
    }
`
export const CreateAt =  styled.div`
    color: #515151;
    font-size : 12px;
    font-wight: 300;
    margin-left :auto;
    margin-bottom : 4.6px;
`

export const Input = styled.input`
  text-align : left;
  border : none;
  border-bottom  : 1px solid #ccc;
  padding : 3px ;
  font-size: 12px;
  width : 100%;
`